import linkifyHtml from 'linkify-html';
import { isString } from 'lodash';

/**
 * Converts URLs in a text string to HTML links.
 *
 * @param {string} input - The text string that may contain URLs.
 * @returns {string} The input text with URLs converted to HTML links.
 * @throws {Error} If the input is not a string.
 * @example
 * // Returns 'Visit <a href="https://example.com" class="link" target="_blank">https://example.com</a> for more information.'
 * convertLinksToHTML('Visit https://example.com for more information.');
 */
export function convertLinksToHTML(input: string): string {
  if (!isString(input)) {
    throw new Error('Input must be a string');
  }
  return linkifyHtml(input, {
    className: 'link',
    target: '_blank',
  });
}
